import React, { useEffect, useState } from "react";
import { Row, Col, Button, Layout } from "antd";
import "./HeroSection.scss";
import { PORTAL_BASE_URL, CALENDLY_LINK, REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from "../../../env";
import posthog from "posthog-js";
import VidLoader from "../../VidLoader/VidLoader";
const { Content } = Layout;


const HeroSection = () => {
    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    )
}

const WebVersion = () => {
    const [showVideo, setShowVideo] = useState(false);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const utm_source = localStorage.getItem('utm_source') || null;
    const redirectPath = `/select-subscription?plan=free_trial&plan_type=smb_3d_services&utm_source=${utm_source}`;

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShowVideo(true);
        }, 100); // slightly defer loading after first paint

        return () => clearTimeout(timeout);
    }, []);

    const handleVideoLoad = () => {
        setVideoLoaded(true);
    };

    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid hero-section-wrapper">
                <Col span={16} className="direction-flex coll justify-in-center">
                    <div className="manrope f-50 w-600 lh-60 mb-20 white heading-text text-center">
                        The AI-powered product <br /> visualization platform for ecommerce
                    </div>
                    <div className="hero-section-description manrope f-16 w-500 lh-24 white text-center">
                        Create unlimited AI images, get 3D CGI, manage assets, and collaborate with your team—all in one powerful platform.
                    </div>
                </Col>
                <Col span={24} className="justify-in-center button-section">
                    <Button onClick={() => {
                        const urlParams = new URLSearchParams(window.location.search);
                        const email = urlParams.get('email') || "";
                        const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                            api_host: POSTHOG_API_HOST,
                            autocapture: false,
                            name: "register",
                            capture_pageview: false,
                            loaded: (ph) => {
                                if (utm_source) ph.register({ utm_source: utm_source });
                            },
                        });
                        if (ph) {
                            ph.capture('free_trial_click', {
                                location: window.location.pathname,
                                button: 'get_started_for_free',
                                utm_source: utm_source,
                                email: email
                            });
                        }
                        window.location.href = `${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`
                    }
                    }
                        className={`manrope f-16 w-500 lh-24 blue-button gradient-button`}>
                        Try AI images for free
                    </Button>
                    <Button onClick={() => {
                        const urlParams = new URLSearchParams(window.location.search);
                        const email = urlParams.get('email') || "";
                        const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                            api_host: POSTHOG_API_HOST,
                            autocapture: false,
                            name: "register",
                            capture_pageview: false,
                            loaded: (ph) => {
                                if (utm_source) ph.register({ utm_source: utm_source });
                            },
                        });
                        if (ph) {
                            ph.capture('schedule_demo_click', {
                                location: window.location.pathname,
                                button: 'schedule_a_demo',
                                utm_source: utm_source,
                                email: email
                            });
                        }
                        window.open(CALENDLY_LINK, "_blank")
                    }}
                        className={`manrope f-16 w-500 lh-24 transparent-blue-btn ml-16`}>
                        Schedule a 3D demo
                    </Button>
                </Col>
                <Col span={24} className="learn-more-section">
                    <a href="/ai-images" className="manrope f-14 w-500 lh-22 white learn-more-link">
                        Check out our AI Images
                    </a>
                </Col>
                <Col className="justify-in-center img-section">
                    <div className="hero-video-container">
                        <video controls poster="/new_homepage/white-bggg.jpg"
                            className="video-dim"
                            onLoadedData={(e) => {
                                e.target.classList.add('loaded');
                                handleVideoLoad();
                            }}
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="auto"
                            src="https://d48f7equ64qjl.cloudfront.net/static_files/ALL3D_Homepage">
                            Your browser does not support the video tag.
                        </video>
                        {!videoLoaded && <VidLoader />}
                    </div>
                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {
    const [videoLoaded, setVideoLoaded] = useState(false);
    const utm_source = localStorage.getItem('utm_source') || null;
    const redirectPath = `/select-subscription?plan=free_trial&plan_type=smb_3d_services&utm_source=${utm_source}`;

    const handleVideoLoad = () => {
        setVideoLoaded(true);
    };

    return (<Content className="d-lg-none">
        <Row className="container-fluid hero-section-wrapper">
            <Col span={24}>
                <h1 className="manrope f-38 w-600 white lh-46 mb-16 text-center">
                    The AI-powered product visualization platform for ecommerce
                </h1>
                <h5 className="manrope f-16 w-500 white lh-24 mb-24 text-center">
                    Create unlimited AI images, get 3D CGI, manage assets, and collaborate with your team—all in one powerful platform.
                </h5>
                <Button onClick={() => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const email = urlParams.get('email') || "";
                    const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                    const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                        api_host: POSTHOG_API_HOST,
                        autocapture: false,
                        name: "register",
                        capture_pageview: false,
                        loaded: (ph) => {
                            if (utm_source) ph.register({ utm_source: utm_source });
                        },
                    });
                    if (ph) {
                        ph.capture('free_trial_click', {
                            location: window.location.pathname,
                            button: 'get_started_for_free',
                            utm_source: utm_source,
                            email: email
                        });
                    }
                    window.location.href = `${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`
                }
                }
                    className={`manrope f-16 w-500 lh-24 blue-button w-100 mb-8 gradient-button`}
                >
                    Try AI images for free
                </Button>
                <Button onClick={() => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const email = urlParams.get('email') || "";
                    const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                    const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                        api_host: POSTHOG_API_HOST,
                        autocapture: false,
                        name: "register",
                        capture_pageview: false,
                        loaded: (ph) => {
                            if (utm_source) ph.register({ utm_source: utm_source });
                        },
                    });
                    if (ph) {
                        ph.capture('schedule_demo_click', {
                            location: window.location.pathname,
                            button: 'schedule_a_demo',
                            utm_source: utm_source,
                            email: email
                        });
                    }
                    window.open(CALENDLY_LINK, "_blank")
                }}
                    className={`manrope f-16 w-500 lh-24 transparent-blue-btn w-100 mb-16`}
                >
                    Schedule a 3D demo
                </Button>
                <a href="/ai-images" className="manrope f-16 w-500 lh-24 white text-center d-block mb-40" style={{ textDecoration: 'underline' }}>
                    Check out our AI Images
                </a>
            </Col>
        </Row>
        <Col span={24} className="justify-in-center img-section-mobile">
            <div className="hero-video-container-mobile">
                <video controls poster="/new_homepage/white-bggg.avif"
                    className="hero-img-dim-mobile"
                    onLoadedData={handleVideoLoad}
                    autoPlay
                    loop
                    muted
                    playsInline
                    src="https://d48f7equ64qjl.cloudfront.net/static_files/ALL3D_Homepage">
                    Your browser does not support the video tag.
                </video>
                {!videoLoaded && <VidLoader />}
            </div>
        </Col>
    </Content>)
}

export default HeroSection;
